import { useEffect, useState } from "react";
import { ColumnItem } from "../../../common/models/table";
import { useMissingStore } from "./store/MissingStore";
import { TitleHeader } from "../../../common/components/TitleHeader/TitleHeader";
import { LFTableV3 } from "../../../common/components/LFTable/LFTableV3";
import { ActionsKey } from "../../../common/models/Actions";
import { MissingService } from "./core/_request";
import { HttpStatusCode } from "axios";
import { CustomDrawer } from "../../../common/components/Drawer/CustomDrawer";
import { MissingForm } from "./components/MissingForm";
import { Loader } from "../../../common/components/Loader/Loader";

export const MissingPage = () => {
  const {
    list,
    setList,
    actioned,
    totalItems,
    setActioned,
    pageState,
    resetPageState,
    setPageState,
  } = useMissingStore();

  const [isShowForm, setIsShowForm] = useState<boolean>(false);
  const [isLoading, setIsLoading] = useState<boolean>(false);

  useEffect(() => {
    fetchAllList(pageState);
  }, [pageState]);

  useEffect(() => {
    if (!isShowForm) {
      setActioned({ action: "no", data: null });
    }
  }, [isShowForm]);

  const onShowAddHandler = () => {
    setIsShowForm((prev: boolean) => !prev);
  };

  const onClickOnAdd = () => {
    onShowAddHandler();
  };

  const handleSetParams = (params: any) => {
    setPageState({
      ...params,
    });
  };

  const fetchAllList = async (params?: any) => {
    try {
      setIsLoading(true);
      const res = await MissingService.getAllMissing(params);
      if (res?.status === HttpStatusCode.Ok) {
        setList(res?.data);
      }
    } catch (error) {
      console.log(error);
    } finally {
      setIsLoading(false);
    }
  };

  const onActionClick = (item: any, action: ActionsKey) => {
    if (action === "delete") {
      onDeleteHandler(item?.id);
    } else {
      getOne(item?.id, action);
    }
  };

  const getOne = async (id: number, action: any) => {
    try {
      setIsLoading(true);
      const res = await MissingService.getOneStaff(id);
      if (res?.status === HttpStatusCode.Ok) {
        setActioned({
          data: {
            ...res?.data,
          },
          action,
        });
      }
      onShowAddHandler();
    } catch (error) {
      console.log(error);
    } finally {
      setIsLoading(false);
    }
  };

  const onDeleteHandler = async (id: number) => {
    try {
      setIsLoading(true);
      const res = await MissingService.deleteMissing(id);
      if (res?.status === HttpStatusCode.NoContent) {
        await fetchAllList(pageState);
      }
    } catch (error) {
      console.log(error);
    } finally {
      setIsLoading(false);
    }
  };

  const onFinishAction = () => {
    resetPageState();
    onShowAddHandler();
    fetchAllList(pageState);
  };

  const cols: ColumnItem[] = [
    {
      key: "absenceType",
      title: "Type",
      dataIndex: "absenceType",
      show: true,
      isCanSort: true,
      render: (state: any) => {
        return (
          <div className="h-100 w-100 d-flex align-items-center justify-content-center">
            <span>{state?.name}</span>
          </div>
        );
      },
    },
    {
      key: "staff",
      title: "Employée",
      dataIndex: "staff",
      show: true,
      isCanSort: true,
      render: (state: any) => {
        return (
          <div className="h-100 w-100 d-flex align-items-center justify-content-center">
            <span>{state?.fullname}</span>
          </div>
        );
      },
    },
    {
      key: "reason",
      title: "Raison",
      dataIndex: "reason",
      show: true,
      isCanSort: true,
    },
    {
      key: "startAt",
      title: "Début",
      dataIndex: "startAt",
      show: true,
      isCanSort: true,
      render: (state: any) => {
        return (
          <div className="h-100 w-100 d-flex align-items-center justify-content-center">
            <span>{state}</span>
          </div>
        );
      },
    },
    {
      key: "endAt",
      title: "Fin",
      dataIndex: "endAt",
      show: true,
      isCanSort: true,
      render: (state: any) => {
        return (
          <div className="h-100 w-100 d-flex align-items-center justify-content-center">
            <span>{state}</span>
          </div>
        );
      },
    },
  ];
  return (
    <div className="">
      <Loader isLoading={isLoading} />

      <TitleHeader
        title="Gestion des absences"
        isSHowBack
        isEnableAdd
        onClickOnAdd={onClickOnAdd}
      />
      <div className="mt-4">
        <LFTableV3
          columns={cols}
          data={list}
          params={pageState}
          onAction={onActionClick}
          isCanEdit={() => true}
          isCanDelete={() => true}
          onSearch={handleSetParams}
          onSort={handleSetParams}
          onResetSearch={resetPageState}
          pagination={{
            defaultCurrentPage: pageState.page,
            itemsPerPage: pageState?.itemsPerPage,
            totalItems: totalItems,
          }}
          onChangePage={handleSetParams}
        />
      </div>

      {/* Drawer section  */}
      {isShowForm ? (
        <CustomDrawer
          isOpen={isShowForm}
          onClose={onShowAddHandler}
          title={actioned?.action === "update" ? "Modification" : "Nouveau"}
          width={"75%"}
        >
          <MissingForm
            onFinish={onFinishAction}
            {...(actioned?.action === "update"
              ? {
                  initialValue: actioned?.data,
                }
              : {})}
          />
        </CustomDrawer>
      ) : (
        ""
      )}
    </div>
  );
};
